module.exports = __webpack_public_path__ + "img/habi.c612a523.png";